export const ContractorSubmittalsEndPoints = {
  procurementLogReadSpecificSubmittalContractor: {
    url: (company, id, entryID) =>
      `/rest/v1/procurementLogReadSpecificSubmittalContractor/${company}/${id}/${entryID}`,
    method: "GET",
  },
  procurementLogContractorEditEntry: {
    url: (company, id) =>
      `/rest/v1/procurementLogContractorEditEntry/${company}/${id}`,
    method: "PUT",
  },
};
